import styled from '@emotion/styled'
import { Stack } from '@mui/material'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import { OrganizationFull } from 'api/model'
import { COLORS } from 'app-constants'

const LogoContainer = styled.div`
  position: relative;
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 9.6px;
  border: 1px solid #dddddd;
  background: white;
  font-size: 32px;
`

const LogoImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const FallbackOrganizationLogo = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ width: '100%', height: '100%', background: COLORS.JELLED_PRIMARY_BLUE }}>
      <AccountBalanceIcon sx={{ fill: 'white', fontSize: 'inherit' }} />
    </Stack>
  )
}

const OrganizationLogo = ({ organization, style }: { organization: OrganizationFull; style?: React.CSSProperties }) => {
  return (
    <LogoContainer style={style}>
      {organization.picture ? (
        <LogoImg src={organization.picture} alt={`${organization.name} Logo`} />
      ) : (
        <FallbackOrganizationLogo />
      )}
    </LogoContainer>
  )
}

export default OrganizationLogo
